import { render, staticRenderFns } from "./problem-cancel.vue?vue&type=template&id=e1424c44&scoped=true"
import script from "./problem-cancel.vue?vue&type=script&lang=js"
export * from "./problem-cancel.vue?vue&type=script&lang=js"
import style0 from "./problem-cancel.vue?vue&type=style&index=0&id=e1424c44&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1424c44",
  null
  
)

export default component.exports